import { render, staticRenderFns } from "./ScreenAbout.vue?vue&type=template&id=7b661c5b&scoped=true&"
import script from "./ScreenAbout.vue?vue&type=script&lang=js&"
export * from "./ScreenAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b661c5b",
  null
  
)

export default component.exports